// @flow

import cookies from 'js-cookie';
import isBrowser from '../isBrowser';
import type { Req } from '../../types/server';

export default (key: string, req?: Req): ?string => {
  if (req && req.cookies) {
    return req.cookies[key];
  }
  return isBrowser() ? cookies.get(key) : null;
};
